// src/admin/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../services/adminAuth.api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useContext } from "react";
import { AdminLanguageContext } from "./context/AdminLanguageContext";

function AdminLogin() {
  const navigate = useNavigate();
  const context = useContext(AdminLanguageContext);
const lang = context?.lang || "EN";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const TEXT = {
  EN: {
    title: "Admin Login",
    username: "Username",
    password: "Password",
    usernamePlaceholder: "Enter your username",
    passwordPlaceholder: "Enter your password",
    login: "Log in",
    logging: "Logging in...",
    error: "Login failed",
  },
  AR: {
    title: "تسجيل دخول الإدارة",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    usernamePlaceholder: "أدخل اسم المستخدم",
    passwordPlaceholder: "أدخل كلمة المرور",
    login: "تسجيل الدخول",
    logging: "جارٍ تسجيل الدخول...",
    error: "فشل تسجيل الدخول",
  },
}[lang];

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await adminLogin({ username, password });

      localStorage.setItem("adminToken", res.token);
      localStorage.setItem("adminUser", JSON.stringify(res.admin));

      localStorage.setItem(
        "staffPermissions",
        JSON.stringify(res.permissions || {})
      );

      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message || TEXT.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
  id="admin-login-root"
  className="min-h-screen bg-[#f6f6f7] flex items-center justify-center px-4"
>

      {/* LOGIN CARD */}
      <div className="w-full max-w-[420px] bg-white border border-gray-200 rounded-2xl p-8">

        {/* TITLE */}
        <h1 className="text-2xl font-semibold text-gray-900 text-center mb-6">
          {TEXT.title}
        </h1>

        {/* ERROR */}
        {error && (
          <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4 border border-red-200">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">

          {/* USERNAME */}
          <div>
            <label className="text-sm text-gray-600 mb-1 block">
              {TEXT.username}
            </label>

            <input
              type="text"
              placeholder={TEXT.usernamePlaceholder}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="
                w-full
                px-4
                py-3
                border
                border-gray-300
                rounded-lg
                text-sm
                focus:outline-none
                focus:ring-2
                focus:ring-black
              "
            />
          </div>

          {/* PASSWORD */}
<div>
  <label className="text-sm text-gray-600 mb-1 block">
    {TEXT.password}
  </label>

  <div className="relative">

    <input
      type={showPassword ? "text" : "password"}
      placeholder={TEXT.passwordPlaceholder}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      className="
        w-full
        px-4
        py-3
        pr-12
        border
        border-gray-300
        rounded-lg
        text-sm
        transition
        focus:outline-none
        focus:border-black
        focus:ring-1
        focus:ring-black
      "
    />

    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      className="
        absolute
        right-3
        top-1/2
        -translate-y-1/2
        text-gray-400
        hover:text-gray-700
        transition
        duration-200
      "
    >
      <span className="transition-opacity duration-200">
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </button>

  </div>
</div>

          {/* LOGIN BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className="
              w-full
              bg-black
              text-white
              py-3
              rounded-lg
              text-sm
              font-semibold
              hover:bg-gray-900
              transition
              disabled:opacity-60
            "
          >
            {loading ? TEXT.logging : TEXT.login}
          </button>

        </form>
      </div>

    </div>
  );
}

export default AdminLogin;